<template>
  <div class="header__wrapper">
    <header id="header">
      <!-- <img src="images/logo.svg" alt="Manumech Logo" class="logo" /> --><a
        href="/"
      >
        <span class="logo__text"
          >Manumech<span class="logo__subtext">Engineering</span></span
        ></a
      >

      <div>
        <nav>
          <ul class="nav__links">
            <li><router-link to="/services">Services</router-link></li>
            <li><router-link to="/capacities">Capacities</router-link></li>
            <li><router-link to="/about">Portfolio</router-link></li>
            <!-- <li><a href="#gallery">Gallery</a></li> -->
            <li>
              <a href="tel:01981251651"
                ><button class="med__button">Contact</button></a
              >
            </li>
            
          </ul>
        </nav>
      </div>
      <div class="mobile__menu">
        <input type="checkbox" id="toggle" />
        <label for="toggle" class="hamburger">
          <div class="hamburger__top"></div>
          <div class="hamburger__meat"></div>
          <div class="hamburger__bottom"></div>
        </label>
        <div class="hamburger__nav">
          <div @click="HideNav" class="hamburger__nav--wrapper">
            <nav class="hamburger__nav--items">
              <router-link to="/services">Services</router-link>
            <router-link to="/capacities">Capacities</router-link>
            <router-link to="/about">Portfolio</router-link>

              <!-- <a href="#gallery">Gallery</a> -->
              <a href="tel:01981251651">Phone</a>
              <a
                href="mailto:manumechltd@hotmail.com?subject=Manumech Website Enquiry"
                >Email</a
              >
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Header',
  methods: {
    HideNav() {
      var checkBox = document.getElementById('toggle')
      checkBox.checked = !checkBox.checked
    },
  },
  components: {},
}
</script>

<style>
.header__wrapper {
  background-color: #080515;
}

@media screen and (max-width: 500px) {
  .logo__subtext {
    display: none;
  }
}
</style>
